module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki10_sp-96bbfb28702047e894647c2f81547ae3.jpg";